import { MasterButton, Modal, InputTextMaster } from "App/Component/ui"
import { Grid, Switch, Typography } from "@material-ui/core"
import React, { useState, useContext } from "react"
import {
  DEFAULT_SHOW_BUTTON_SUBMIT,
} from "App/constants"
import {
  formatRupiah,
  convertToValidPrice,
} from "App/utils/helpers"
import { FormContext } from "../../context/FormContext"

const ModalPotongan = ({
  setShowModal,
  setNewDataPembelianList,
  getPerhitunganListPembelian,
  tempJumlah,
}) => {
  const [disabled, setDisabled] = useState(DEFAULT_SHOW_BUTTON_SUBMIT)

  const { formData, setFormData } = useContext(FormContext)

  const handleSubmit = async (e) => {
    e.preventDefault()
    setShowModal(false);
    getPerhitunganListPembelian();
  }

  const handleChange = (event) => {
    setFormData({
      ...formData,
      is_persentase_potongan: event.target.checked,
      diskon_persen: 0,
      potongan: 0,
      potongan2: 0,
    })
  }

  return (
    <Modal title={"Potongan"} show={setShowModal}>
      <form onSubmit={(e) => handleSubmit(e)}>
        <Grid container direction="row" alignItems="center">
          <Grid item sm={12}>
            <div
              style={{
                display: "flex",
                gap: "2px",
                alignItems: "center",
              }}
            >
              <Typography style={{ fontWeight: "bold" }}>RP</Typography>
              <Switch
                checked={formData.is_persentase_potongan}
                color="primary"
                onChange={handleChange}
                inputProps={{ "aria-label": "controlled" }}
              />
              <Typography style={{ fontWeight: "bold" }}>%</Typography>
            </div>
          </Grid>
          <Grid item sm={12}>
            <InputTextMaster
              name="disc"
              label={formData.is_persentase_potongan ? "DISC (%)" : "DISC (RP)"}
              id="disc"
              placeholder="Dalam Rupiah"
              value={
                formData.is_persentase_potongan
                  ? formData.diskon_persen
                  : formData.potongan2
              }
              onInput={(e) => {
                let val = e.target.value
                if (formData.is_persentase_potongan) {
                  const potongan = (val / 100) * tempJumlah
                  setFormData({
                    ...formData,
                    potongan: convertToValidPrice(potongan),
                    potongan2: formatRupiah(potongan),
                    diskon_persen: val,
                  })
                } else {
                  setFormData({
                    ...formData,
                    potongan: convertToValidPrice(val),
                    potongan2: formatRupiah(val),
                    diskon_persen: 0,
                  })
                }
              }}
            />
          </Grid>
        </Grid>

        <div>
          <Grid
            container
            direction="row"
            justifyContent="flex-end"
            alignItems="center"
          >
            <MasterButton
              className={"mt-1"}
              type="submit"
              color={disabled.color}
              name={disabled.label}
              disabled={disabled.state}
              size="md"
            />
          </Grid>
        </div>
      </form>
    </Modal>
  )
}

export default ModalPotongan
